document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('[js-main-products-media-swiper]')) return;

  const mainProductThumbSwiper = new Swiper("[js-main-products-media-thumbnails-swiper]", {
    spaceBetween: 15,
    slidesPerView: 4.5,
    allowTouchMove: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    breakpoints: {
      360: { spaceBetween: 10 },
      960: { spaceBetween: 15 },
    },
  });

  const mainProductSwiper = new Swiper('[js-main-products-media-swiper]', {
    allowTouchMove: false,
    slidesPerView: 1,
    effect: 'fade',
    autoHeight: true,
    navigation: {
      nextEl: ".swiper-button-next__container",
      prevEl: ".swiper-button-prev__container",
    },
    thumbs: {
      swiper: mainProductThumbSwiper,
    },
  });

  mainProductSwiper.controller.control = mainProductThumbSwiper;

  window.productGallerySlider = mainProductSwiper;
})
